// display error if no application to use fax number found on your device
document.addEventListener('DOMContentLoaded', function() {
    const faxLinks = document.querySelectorAll('.fax-link');
    faxLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            const errorMsg = this.closest('h3').nextElementSibling;
            // Use a timeout to detect if the browser couldn't handle the protocol
            let windowBlurred = false;
            const blurHandler = function() {
                windowBlurred = true;
            };
            window.addEventListener('blur', blurHandler);
            
            setTimeout(function() {
                window.removeEventListener('blur', blurHandler);
                if (!windowBlurred && errorMsg && errorMsg.classList.contains('fax-error')) {
                    errorMsg.classList.remove('visually-hidden');
                    errorMsg.removeAttribute('aria-hidden');
                }
            }, 500);
        });
    });
});